<template>
  <div class="consultantInfo">
    <div class="pageItemTools" v-if="showHis">
      <div @click="goDetail(consultantInfoForm, 'HI')">
        <Tooltip content="热线咨询" transfer>
          <div class="magContent">
            <span class="msgIcon telIcon"></span>
            <span class="msgValue">{{consultantInfoForm?.HINum || 0}}</span>
          </div>
        </Tooltip>
      </div>
      <div @click="goDetail(consultantInfoForm, 'IM')">
        <Tooltip content="即时咨询" transfer>
          <div class="magContent">
            <span class="msgIcon imIcon"></span>
            <span class="msgValue">{{consultantInfoForm?.IMNum || 0}}</span>
          </div>
          <!-- <Icon size="16" type="ios-create" /> -->
        </Tooltip>
      </div>
      <div @click="goDetail(consultantInfoForm, 'MC')">
        <Tooltip content="留言咨询" transfer>
          <div class="magContent">
            <span class="msgIcon mcIcon"></span>
            <span class="msgValue">{{consultantInfoForm?.MCNum || 0}}</span>
          </div>
        </Tooltip>
      </div>
      <!-- 
      <div @click="goDetail(consultantInfoForm, 'OFFLINE')">
        <Tooltip content="实体咨询" transfer>
          <div class="magContent">
            <span class="msgIcon offlineIcon"></span>
            <span class="msgValue">{{consultantInfoForm?.OFFLINENum || 0}}</span>
          </div>
        </Tooltip>
      </div>-->
    </div>
    <div class="pageItemContent custom-scroll">
      <!-- <div class="img">
        <img
          :src="consultantInfoForm?.avatar || require('@/assets/static/images/im/consultant@2x.png')"
          @error="imgOnError"
          class="personIcon"
        />
      </div>-->
      <div>
        <Form :model="consultantInfoForm" class="smallForm" ref="consultantForm">
          <FormItem label="联系方式" prop="telPhone">
            <Input
              :value="$options.filters.desensitizedPhone(consultantInfoForm.telPhone)"
              autocomplete="off"
              disabled
              placeholder="请输入咨询人联系方式"
              type="text"
            ></Input>
          </FormItem>

          <template v-if="consultantInfoForm.name">
            <FormItem label="姓名" prop="name">
              <Input
                :value="$options.filters.desensitizedName(consultantInfoForm.name)"
                autocomplete="off"
                disabled
                placeholder="请输入咨询人名"
                type="text"
              ></Input>

              <!-- <Input
              clearable
              placeholder="请输入咨询人名"
              type="text"
              v-model.trim="consultantInfoForm.name"
              ></Input>-->
            </FormItem>
          </template>
          <template v-else>
            <FormItem label="姓名" prop="changeName">
              <Input
                autocomplete="off"
                placeholder="请输入咨询人名"
                type="text"
                v-model="consultantInfoForm.changeName"
              ></Input>
            </FormItem>
          </template>
          <FormItem label="性别" prop="leGender">
            <Select
              autocomplete="off"
              filterable
              placeholder="请选择性别"
              transfer
              v-model="consultantInfoForm.leGender"
            >
              <Option value="MALE">男</Option>
              <Option value="FEMALE">女</Option>
              <Option value="UNKNOWN">未知</Option>
            </Select>
          </FormItem>

          <FormItem label="年龄段" prop="leAges">
            <Select
              autocomplete="off"
              clearable
              filterable
              placeholder="请选择年龄段"
              v-model="consultantInfoForm.leAges"
            >
              <Option :key="item.val" :value="item.val" v-for="item in ages">{{ item.label }}</Option>
            </Select>
          </FormItem>

          <FormItem label="客户类别" prop="leConsultationType">
            <Select
              autocomplete="off"
              clearable
              filterable
              placeholder="请选择客户类别"
              v-model="consultantInfoForm.leConsultationType"
            >
              <Option
                :key="item.val"
                :value="item.val"
                v-for="item in consultationTypes"
              >{{ item.label }}</Option>
            </Select>
          </FormItem>

          <FormItem label="证件类型">
            <Select
              autocomplete="off"
              filterable
              placeholder="请选择证件类型"
              transfer
              v-model="consultantInfoForm.leCredentialsType"
            >
              <Option
                :key="paperType.value"
                :value="paperType.value"
                v-for="paperType in paperTypes"
              >{{ paperType.label }}</Option>
            </Select>
          </FormItem>

          <FormItem label="证件号码">
            <Input
              autocomplete="off"
              clearable
              placeholder="请输入证件号码"
              type="text"
              v-model.trim="consultantInfoForm.leCredentialsNum"
            ></Input>
          </FormItem>

          <FormItem label="职业" prop="leProfession">
            <Select
              autocomplete="off"
              clearable
              filterable
              placeholder="请选择职业"
              v-model="consultantInfoForm.leProfession"
            >
              <Option :key="item.val" :value="item.val" v-for="item in professions">{{ item.label }}</Option>
            </Select>
          </FormItem>

          <FormItem label="学历" prop="leEducational">
            <Select
              autocomplete="off"
              clearable
              filterable
              placeholder="请选择学历"
              v-model="consultantInfoForm.leEducational"
            >
              <Option
                :key="item.val"
                :value="item.val"
                v-for="item in educationals"
              >{{ item.label }}</Option>
            </Select>
          </FormItem>

          <FormItem label="行业">
            <Select
              autocomplete="off"
              clearable
              filterable
              placeholder="请选择行业"
              v-model="consultantInfoForm.leIndustry"
            >
              <Option :key="item.val" :value="item.val" v-for="item in industrys">{{ item.label }}</Option>
            </Select>
          </FormItem>

          <FormItem label="客户来源">
            <Select
              autocomplete="off"
              clearable
              filterable
              placeholder="请选择客户来源"
              v-model="consultantInfoForm.leConsultationSource"
            >
              <Option
                :key="item.val"
                :value="item.val"
                v-for="item in consultationSources"
              >{{ item.label }}</Option>
            </Select>
          </FormItem>

          <FormItem label="方言">
            <Select
              autocomplete="off"
              clearable
              filterable
              placeholder="请选择方言"
              v-model="consultantInfoForm.leDialect"
            >
              <Option :key="item.val" :value="item.val" v-for="item in dialects">{{ item.label }}</Option>
            </Select>
          </FormItem>

          <FormItem label="工作单位">
            <Input
              autocomplete="off"
              clearable
              placeholder="请输入工作单位"
              type="text"
              v-model.trim="consultantInfoForm.leWorkUnit"
            ></Input>
          </FormItem>

          <FormItem label="所在地">
            <Cascader
              :data="regionData"
              placeholder="请选择所在地"
              v-model.trim="consultantInfoForm.areaCodes"
            ></Cascader>
          </FormItem>
        </Form>
        <div class="textL">
          <Tag
            :color="tag.color"
            :key="tag.id + '-'+consultantInfoForm?.id"
            type="border"
            v-for="tag in consultantInfoForm?.tags"
          >{{tag.name}}</Tag>
        </div>
      </div>
      <template v-if="consultantInfoForm?.NLPOpen">
        <emotionChart :id="consultantInfoForm?.id" :pieData="consultantInfoForm?.emotions"></emotionChart>
      </template>
    </div>

    <div class="saveBtn">
      <Button @click="updateConsultion" size="small" type="text">
        <i class="iconfont icon-save2" />
        保存
      </Button>
    </div>

    <Modal
      :mask-closable="false"
      @on-cancel="onFullHisCancel"
      footer-hide
      title="历史咨询信息"
      v-model="showFullHis"
      width="70vw"
    >
      <div class="content" style="max-height: 60vh; overflow-y:auto">
        <Tabs @on-click="changeHisType" type="card" v-if="showFullHis" v-model="currentType">
          <Tab-pane label="即时咨询" name="IM">
            <Table :columns="imColumns" :data="imConsultions" size="small" />
            <div style="text-align: right; margin: 10px 0">
              <Page
                :total="imPage.total"
                @on-change="changeIMPage"
                @on-page-size-change="changeIMPageSize"
                show-elevator
                show-sizer
                show-total
                size="small"
                transfer
              ></Page>
            </div>
          </Tab-pane>
          <Tab-pane label="留言咨询" name="MC">
            <Table :columns="mcColumns" :data="mcConsultions" size="small" />
            <div style="text-align: right; margin: 10px 0">
              <Page
                :total="mcPage.total"
                @on-change="changeMCPage"
                @on-page-size-change="changeMCPageSize"
                show-elevator
                show-sizer
                show-total
                size="small"
                transfer
              ></Page>
            </div>
          </Tab-pane>
          <Tab-pane label="热线咨询" name="HI">
            <Table :columns="hiColumns" :data="hiConsultions" size="small" />
            <div style="text-align: right; margin: 10px 0">
              <Page
                :total="hiPage.total"
                @on-change="changeHIPage"
                @on-page-size-change="changeHIPageSize"
                show-elevator
                show-sizer
                show-total
                size="small"
                transfer
              ></Page>
            </div>
          </Tab-pane>
          <!-- <Tab-pane label="实体咨询" name="OFFLINE">
            <Table :columns="offlineColumns" :data="offlineConsultions" size="small" />
            <div style="text-align: right; margin: 10px 0">
              <Page
                :total="offlinePage.total"
                @on-change="changeOfflinePage"
                @on-page-size-change="changeOfflinePageSize"
                show-elevator
                show-sizer
                show-total
                size="small"
                transfer
              ></Page>
            </div>
          </Tab-pane>-->
        </Tabs>
      </div>
    </Modal>

    <Modal @on-cancel="onIMHisCancel" footer-hide title="即时咨询记录" v-model="showIMHis" width="70vw">
      <div class="content" style="max-height: 60vh; overflow-y:auto">
        <ul v-if="chartHisMessages && chartHisMessages.length > 0">
          <li :key="item.id+'-' + index + '-his'" v-for="(item, index) in chartHisMessages">
            <messageInfoHis
              :message="item"
              :userInfo="allUserInfos[item.sendUserId]"
              class="allHisMessageItem"
            ></messageInfoHis>
          </li>
        </ul>
        <div style="line-height: 4rem" v-else>暂无历史信息</div>
        <water-mark></water-mark>
      </div>
    </Modal>

    <Modal
      :lock-scroll="false"
      :mask-closable="false"
      :styles="{top: '50px'}"
      :title="`热线台账详情`"
      @on-cancel="cancelView"
      footer-hide
      v-model="showHLDetail"
      width="90vw"
    >
      <div class="content" style="max-height: 60vh; overflow-y:auto">
        <HLSimpleDetail
          :consultationInfo="consultationInfo"
          :edit="false"
          ref="hlDetail"
          v-if="showHLDetail"
        />
      </div>
    </Modal>
  </div>
</template>
<script>
import messageInfoHis from './IM-support/messageInfoHis'
import emotionChart from '@/views/systemManage/consultantManager/portrait/emotionChart.vue'
import HLSimpleDetail from '@/views/systemManage/ICHL/HLSimpleDetail.vue'
export default {
  name: 'consultantPortrait',
  components: {
    emotionChart, messageInfoHis, HLSimpleDetail
  },
  props: {
    consultantInfo: {
      required: true
    },
    showHis: {
      required: false,
      default: true
    },
  },
  watch: {
    consultantInfo: {
      deep: true,
      immediate: true,
      handler (val) {
        this.consultantInfoForm = Object.assign({}, val)
      }
    }
  },
  data () {
    return {

      showHLDetail: false,
      consultationInfo: null,
      consultantInfoForm: {},
      consultationTypes: [],
      ages: [],
      genders: [],
      dialects: [],
      industrys: [],
      credentialsTypes: [],
      educationals: [],
      professions: [],
      consultationSources: [],
      callQueues: [],
      paperTypes: [],
      chartHisMessages: [],
      allUserInfos: {},
      genders: {
        MALE: "男",
        FEMALE: "女",
        UNKNOWN: "未知"
      },
      showFullHis: false,
      currentType: '',
      imPage: {
        total: 0,
        pageSize: 10,
        total: 0,
        pageNo: 1,
        sorts: {}
      },
      imConsultions: [],
      imColumns: [{
        title: "序号",
        align: "center",
        fixed: "left",
        type: "index",
        width: 90,
      }, {

        title: "咨询时间",
        align: "right",
        fixed: "left",
        key: "whenCreated",
        tooltip: true,
        width: 180,
      }, {
        title: "所属区域",
        align: "right",
        // fixed: "left",
        key: "areaName",
        tooltip: true,
        width: 100,
      }, {
        title: "咨询类型",
        align: "left",
        key: "consultationType",
        tooltip: true,
        minWidth: 120,
        render: (h, params) => {
          return h('dicLabel', {
            props: {
              value: params.row.consultationType,
              category: 'CONSULTATION_TYPE'
            }
          })
        }
      },
      {
        title: "咨询内容",
        align: "left",
        key: "question",
        tooltip: true,
        minWidth: 260
      },
      {
        title: "操作",
        align: "center",
        width: 90,
        fixed: "right",
        render: (h, params) => {
          return h('div', [
            h('Button', {
              props: {
                type: 'text',
              },
              attrs: {
                style: 'padding: 0;  color: #009EFC!important;',
              },
              on: {
                'click': () => {
                  this.viewChartHis(params.row)
                }
              },
            }, '详情'),
          ])
        }
      }
      ],
      showIMHis: false,
      chartHisMessages: [],
      mcPage: {
        total: 0,
        pageSize: 10,
        total: 0,
        pageNo: 1,
        sorts: {}
      },
      mcConsultions: [],
      mcColumns: [
        {
          title: "序号",
          align: "center",
          fixed: "left",
          type: "index",
          width: 90,
        },
        {
          title: "状态", align: "left", fixed: "left", key: "commentStatus", tooltip: true, minWidth: 100,
          render: (h, params) => {
            return h('Tag', {
              props: {
                color: params.row.commentStatus == 'APPROVED' ? 'blue' : 'red'
              }
            }, params.row.commentStatus == 'APPROVED' ? '已回复' : '待回复')
          }
        },
        { title: "咨询时间", align: "left", fixed: "left", key: "whenCreated", sortable: "custom", tooltip: true, minWidth: 180, },
        { title: "所属区域", align: "left", tooltip: true, key: "areaName", width: 100, },
        { title: "咨询类型", align: "left", key: "commentTypeLabel", tooltip: true, minWidth: 100 },
        { title: "咨询标题", align: "left", key: "commentTitle", tooltip: true, minWidth: 130, },
        { title: "咨询内容", align: "left", key: "commentInfo", tooltip: true, minWidth: 200, },
        {
          title: "回复内容", align: "left", key: "consultationReply.replyInfo", tooltip: true, minWidth: 200,
          render: (h, params) => {
            return h('div', params.row.consultationReply?.replyInfo)
          }
        },
      ],
      hiPage: {
        total: 0,
        pageSize: 10,
        total: 0,
        pageNo: 1,
        sorts: {}
      },
      hiConsultions: [],
      hiColumns: [
        {
          title: "序号",
          align: "center",
          fixed: "left",
          type: "index",
          width: 90,
        },
        // { title: "咨询时间", align: "left", fixed: "left", key: "callTime", sortable: "custom", tooltip: true, minWidth: 180, },
        // { title: "所属区域", align: "left", tooltip: true, key: "phoneLocation", width: 100, },
        // { title: "咨询时长（秒）", align: "left", key: "talkDuration", tooltip: true, minWidth: 100 },
        // { title: "咨询主题", align: "left", key: "subject", tooltip: true, minWidth: 130, },
        // { title: "话务员名称", align: "left", key: "lawyerName", tooltip: true, minWidth: 130, },
        // { title: "备注", align: "left", key: "clientDescription", tooltip: true, minWidth: 200, }
        {
          title: "台账类型", align: "center", fixed: "left", className: 'noPadding', key: "category", tooltip: true, width: 100, render: (h, params) => {
            let ele = this.$common.categoryMap[params.row.category || 'consultation']
            return h("Tag", {
              props: {
                color: ele.color
              }
            }, ele.label)
          }
        },
        { title: "咨询时间", align: "right", fixed: "left", key: "callTime", tooltip: true, minWidth: 180, },
        {
          title: "话务类型", align: "left", key: "icSubType", tooltip: true, minWidth: 120, render: (h, params) => {
            return h('div', params.row.icSubType == 'HL_FP' ? '固定座席' : '移动座席')
          }
        },
        { title: "呼叫类型", align: "left", key: "callTypeLabel", tooltip: true, minWidth: 120, },
        { title: "所属区域", align: "left", tooltip: true, key: "phoneLocation", width: 100, },
        { title: "咨询时长（秒）", align: "right", key: "talkDuration", tooltip: true, minWidth: 120 },
        { title: "咨询主题", align: "left", key: "subject", tooltip: true, minWidth: 130, },
        { title: "服务律师", align: "left", key: "lawyerName", tooltip: true, minWidth: 130, },
        { title: "律师号码", align: "right", key: "serviceNumber", tooltip: true, minWidth: 130, },
        { title: "备注", align: "left", key: "clientDescription", tooltip: true, minWidth: 200, },
        {
          title: "操作",
          align: "center",
          width: 90,
          fixed: "right",
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'text',
                },
                attrs: {
                  style: 'padding: 0;  color: #009EFC!important;',
                },
                on: {
                  'click': () => {
                    this.viewHLHis(params.row)
                  }
                },
              }, '详情'),
            ])
          }
        }

      ],
      offlinePage: {
        total: 0,
        pageSize: 10,
        total: 0,
        pageNo: 1,
        sorts: {}
      },
      offlineConsultions: [],
      offlineColumns: [
        {
          title: "序号",
          align: "center",
          fixed: "left",
          type: "index",
          width: 90,
        },
        { title: "咨询时间", align: "left", fixed: "left", key: "consultTime", tooltip: true, minWidth: 180, },
        { title: "所属区域", align: "left", tooltip: true, key: "areaName", width: 100, },
        { title: "咨询内容", align: "left", key: "content", tooltip: true, minWidth: 200, },
        { title: "解答人", align: "left", tooltip: true, key: "answeringName", width: 100, },
        { title: "解答机构", align: "left", tooltip: true, key: "answeringAgency", width: 120, },
        { title: "解答内容", align: "left", key: "answerContent", tooltip: true, minWidth: 200, },
        { title: "解答时间", align: "left", fixed: "left", key: "answerTime", tooltip: true, minWidth: 180, },
      ],
      regionData: [],
    }
  },
  methods: {
    viewHLHis: function (row) {
      this.consultationInfo = Object.assign({}, row)
      this.showHLDetail = true
    },
    cancelView: function () {
      this.showHLDetail = false
      this.consultationInfo = null
    },
    imgOnError: function (e) {
      console.log('imgOnError', e)
      // let img = e.srcElement
      e.target.src = require('@/assets/static/images/im/consultant@2x.png')
      e.target.onerror = null
    },
    imgLawyerOnError: function (e) {
      console.log('imgLawyerOnError', e)
      // let img = e.srcElement
      e.target.src = require('@/assets/static/images/im/lawyer@2x.png')
      e.target.onerror = null
    },
    goDetail: function (row, type) {
      this.showFullHis = true
      this.changeHisType(type)
    },
    onFullHisCancel: function () {
      this.showFullHis = false
    },
    changeHisType: function (name) {
      this.currentType = name
      switch (name) {
        case 'IM':
          this.imPage = {
            total: 0,
            pageSize: 10,
            total: 0,
            pageNo: 1,
            sorts: {}
          }
          this.getImConsultions()
          break
        case 'MC':
          this.mcPage = {
            total: 0,
            pageSize: 10,
            total: 0,
            pageNo: 1,
            sorts: {}
          }
          this.getMcConsultions()
          break
        case 'HI':
          this.hiPage = {
            total: 0,
            pageSize: 10,
            total: 0,
            pageNo: 1,
            sorts: {}
          }
          this.getHiConsultions()
          break
        case 'OFFLINE':
          this.offlinePage = {
            total: 0,
            pageSize: 10,
            total: 0,
            pageNo: 1,
            sorts: {}
          }
          this.getOfflineConsultions()
          break
      }
    },
    onIMHisCancel: function () {
      this.chartHisMessages = []
      this.allUserInfos = {}
      this.showIMHis = false
    },
    changeIMPage: function (page) {
      this.imPage.pageNo = page
      this.getImConsultions()
    },
    changeIMPageSize: function (pageSize) {
      this.imPage.pageSize = pageSize
      this.getImConsultions()
    },
    getImConsultions: function () {
      let that = this
      this.imConsultions = []
      let params = new this.$URLSearchParams()
      params.append("pageParams", JSON.stringify(this.imPage))
      // params.append("tel", this.consultantInfoForm.telPhone)
      let oa = {
        telePhone: this.consultantInfoForm.telPhone
      }

      params.append("searchData", JSON.stringify(oa))

      this.$axios.post(this.$apis.ICIMApi.findConsultantHisChart, params).then(res => {
        if (res.success) {
          this.imPage.total = res.result.total || 0
          this.imConsultions = res.result.data || []
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        console.log('err', err)
        that.$Message.error("获取即时咨询历史失败！")
      })
    },
    viewChartHis: function (row) {
      let that = this
      this.showIMHis = true
      let params = new this.$URLSearchParams()
      params.append('groupId', row.groupId)
      that.$axios.post(this.$apis.ICIMApi.getIMHistory, params).then(res => {
        if (res.success) {
          this.chartHisMessages = res.result?.hisMessages || []
          this.allUserInfos = res.result?.userInfos || {}
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        console.log(err)
        that.$Message.error("获取咨询历史记录失败！")
      })
    },
    changeMCPage: function (page) {
      this.mcPage.pageNo = page
      this.getMcConsultions()
    },
    changeMCPageSize: function (pageSize) {
      this.mcPage.pageSize = pageSize
      this.getMcConsultions()
    },
    getMcConsultions: function () {
      let that = this
      this.mcConsultions = []
      let params = new this.$URLSearchParams()
      params.append("pageParams", JSON.stringify(this.mcPage))
      // params.append("tel", this.consultantInfoForm.telPhone)
      let oa = {
        telePhone: this.consultantInfoForm.telPhone
      }

      params.append("searchData", JSON.stringify(oa))
      this.$axios.post(this.$apis.icmcApi.getConsultingHis, params).then(res => {
        if (res.success) {
          this.mcPage.total = res.result.total || 0
          this.mcConsultions = res.result.data || []
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        console.log('getMcConsultions err', err)
        that.$Message.error("获取咨询案例失败！")
      })
    },
    changeHIPage: function (page) {
      this.hiPage.pageNo = page
      this.getHiConsultions()
    },
    changeHIPageSize: function (pageSize) {
      this.hiPage.pageSize = pageSize
      this.getHiConsultions()
    },
    getHiConsultions: function () {
      let that = this
      this.mcConsultions = []
      let params = new this.$URLSearchParams()
      params.append("pageParams", JSON.stringify(this.hiPage))

      // params.append("tel", this.consultantInfoForm.telPhone)
      let oa = {
        telePhone: this.consultantInfoForm.telPhone
      }
      params.append("searchData", JSON.stringify(oa))
      this.$axios.post(this.$apis.ICIMApi.getTelHis, params).then(res => {
        if (res.success) {
          this.hiPage.total = res.result.total || 0
          this.hiConsultions = res.result.data || []
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        console.log('getHiConsultions err', err)
        that.$Message.error("获取热线咨询记录失败！")
      })
    },
    changeOfflinePage: function (page) {
      this.offlinePage.pageNo = page
      this.getOfflineConsultions()
    },
    changeOfflinePageSize: function (pageSize) {
      this.offlinePage.pageSize = pageSize
      this.getOfflineConsultions()
    },
    getOfflineConsultions: function () {
      let that = this
      this.mcConsultions = []
      let params = new this.$URLSearchParams()
      params.append("pageParams", JSON.stringify(this.offlinePage))
      let oa = {
        telePhone: this.consultantInfoForm.telPhone
      }
      params.append("searchData", JSON.stringify(oa))

      this.$axios.post(this.$apis.ICIMApi.getOfflineHis, params).then(res => {
        if (res.success) {
          this.offlinePage.total = res.result.total || 0
          this.offlineConsultions = res.result.data || []
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        console.log('getOfflineConsultions err', err)
        that.$Message.error("获取线下咨询记录失败！")
      })
    },
    initDicValues: function () {
      let that = this
      this.callQueues = []
      this.getDic("CALL_QUEUE").then(val => {
        that.callQueues = val
      })

      this.consultationTypes = []
      this.getDic("LE_CONSULTATION_TYPE").then(val => {
        that.consultationTypes = val
      })

      this.consultationSources = []
      this.getDic("LE_CONSULTATION_SOURCE").then(val => {
        that.consultationSources = val
      })

      this.ages = []
      this.getDic("LE_AGES").then(val => {
        that.ages = val
      })

      this.dialects = []
      this.getDic("LE_DIALECT").then(val => {
        that.dialects = val
      })

      this.industrys = []
      this.getDic("LE_INDUSTRY").then(val => {
        that.industrys = val
      })

      this.credentialsTypes = []
      this.getDic("LE_CREDENTIALS_TYPE").then(val => {
        that.credentialsTypes = val
      })

      this.genders = []
      this.getDic("GENDERS").then(val => {
        that.genders = val
      })

      this.educationals = []
      this.getDic("LE_EDUCATIONAL").then(val => {
        that.educationals = val
      })

      this.professions = []
      this.getDic("LE_PROFESSION").then(val => {
        that.professions = val
      })
    },
    initAreaTree: async function () {
      let that = this
      that.regionData = await this.$baseData.handleData(false, that.$apis.dictionaryManager.region.getLvTree, null) || []

      // this.$axios.post(that.$apis.dictionaryManager.region.getLvTree).then(res => {
      //   if (res.success) {
      //     that.regionData = res.result || []
      //   } else {
      //     that.$Message.error(res.message)
      //   }
      // }).catch(function (err) {
      //   that.$Message.error('区域数据获取失败！')
      // }).then(val => {
      // })
    },
    getPaperTypesOptions: function () {
      let that = this
      this.$axios.post(that.$apis.common.getPaperTypesOptions).then(res => {
        if (res.success) {
          that.paperTypes = res.result || []
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error('证件类型列表获取失败！')
      })
    },
    updateConsultion: function () {
      let that = this
      if (this.consultantInfoForm.areaCodes) {
        this.consultantInfoForm.leProvinceId = this.consultantInfoForm.areaCodes[0]
        this.consultantInfoForm.leCityId = this.consultantInfoForm.areaCodes[1]
        this.consultantInfoForm.leCountyId = this.consultantInfoForm.areaCodes[2]
      }
      if (this.consultantInfoForm.changeName) this.consultantInfoForm.name = that.consultantInfoForm.changeName
      this.$axios.post(this.$apis.consultantManager.consultantInfo.saveOrUpdate, this.consultantInfoForm).then(res => {
        if (res.success) {
          this.$Message.success({
            content: '操作成功！',
            duration: 3
          })
          that.consultantInfoForm = res.result || {}
          that.$emit('change', that.consultantInfoForm)
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        console.log('updateConsultion err', err)
        that.$Message.error("更新咨询人信息失败！")
      })
    },
  },
  beforeMount () {
    this.getPaperTypesOptions()
    this.initDicValues()
    this.initAreaTree()
  }
}
</script>
<style lang="less" scoped>
.saveBtn {
  border-top: 1px solid #e8e8e8;
  text-align: center;
  padding: 5px 0;
  color: rgba(0, 0, 0, 0.45);
  .iconfont {
    font-size: 0.8rem !important;
  }
}
</style>
